import { NotificationTypesEnum } from "@/model/data/enums/NotificationTypesEnum";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { ApiGenericResponse } from "../ApiGenericResponse";

const ENDPOINT = "/notifications/mark_read_all_notifications";

export class MarkAllAsReadCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: MarkAllAsReadReqData;

    constructor(payload: MarkAllAsReadReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<ApiGenericResponse> {
        var res = await this.executeCommand(this.payload);
        return new ApiGenericResponse(res);
    }
}

export class MarkAllAsReadReqData {
    notificationType: NotificationTypesEnum;
}
